import React from 'react'
import { css, cx } from '@emotion/css'
import {
  paragraphHeaderCss,
  paragraphTextCss
} from '../../legacy-design-system/text'
import { MetadataFiltersList } from './metadata-filters-list'
import { theme } from '../../styled/theme'

interface MetadataFiltersSummaryProps {
  readonly filters?: string[]
  readonly vulnsCount: number
  readonly vulnsCountLabel?: React.ReactNode
}

export function MetadataFiltersSummary({
  filters,
  vulnsCount,
  vulnsCountLabel
}: MetadataFiltersSummaryProps) {
  return (
    <div
      className={css`
        flex: 1;
      `}
    >
      {Array.isArray(filters) && filters.length > 0 && (
        <MetadataFiltersList
          filters={filters}
          filterListStyle={paragraphHeaderCss}
        />
      )}

      {vulnsCountLabel && (
        <div
          className={cx(
            paragraphTextCss,
            css`
              margin-top: 7px;
              flex-direction: row;
              display: flex;
            `
          )}
        >
          <span
            className={css`
              margin-right: 4px;
              font-weight: ${theme.fontWeights.primaryCondensed.bold};
            `}
            children={vulnsCount}
          />
          {vulnsCountLabel}
        </div>
      )}
    </div>
  )
}
